module.exports = {
    "collectionLabel": `Suggestions`
};


//# sourceMappingURL=en-US.main.js.map
